import { render, staticRenderFns } from "./InviteTokenHandler.vue?vue&type=template&id=038aa7ec&"
import script from "./InviteTokenHandler.vue?vue&type=script&lang=js&"
export * from "./InviteTokenHandler.vue?vue&type=script&lang=js&"
import style0 from "./InviteTokenHandler.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports